import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const MembersIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M12 2C6.486 2 2 6.486 2 12C2 17.514 6.486 22 12 22C17.514 22 22 17.514 22 12C22 6.486 17.514 2 12 2ZM13.66 14.839L13.487 14.996C13.238 15.228 12.832 15.545 12.436 15.839C12.177 16.032 11.823 16.032 11.564 15.839C11.167 15.543 10.757 15.224 10.503 14.986L10.338 14.836C8.94 13.572 7.435 11.91 8.215 10.28C8.581 9.516 9.377 9.001 10.198 9C10.654 9 11.08 9.124 11.463 9.368L12 9.711L12.538 9.368C12.921 9.124 13.346 9 13.802 9H13.805C14.623 9.001 15.419 9.516 15.785 10.28C16.566 11.91 15.06 13.572 13.66 14.839Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

MembersIcon.propTypes = {
  sx: PropTypes.object,
};

export default MembersIcon;
